import React from 'react';
import { Alert } from '@biome-design-system/ui/Alert';
import { defineMessages, FormattedMessage } from '@kyruus/intl';
import { REDIRECT_ERROR } from '../utils/constants';

const messages = defineMessages({
  errorMessageRedirectGeneral: {
    id: 'error.message.redirect.general',
    description:
      'Error message when we are not able to redirect the user to the appropriate step in the direct book flow following a general error',
    defaultMessage: 'We had trouble processing your request. Please try again.'
  },
  errorMessageRedirectDeeplinkingThirdPartyLogin: {
    id: 'error.message.redirect.deeplinking.third_party_login',
    description:
      'Error message when we are not able to redirect the user to the appropriate step in the direct book flow following a third-party login error',
    defaultMessage:
      'We had trouble logging in and need to restart. You can start a new search and finish booking your appointment.'
  }
});

/**
 * Error message to be displayed as the result of a redirect error.
 *
 * @example
 * Failing to redirect the user to their previous spot in the direct book flow following a third-party login attempt
 * due to an invalid deep-linking URL
 *
 * @param {Object} routeProps Router props object containing the `match`, `history`, and `location`
 * @returns an error banner
 */
export default function RedirectErrorMessage({ location } = {}) {
  let message;
  switch (location.state.redirect_error) {
    case REDIRECT_ERROR.DIRECT_BOOK_DEEPLINKING: {
      message = messages.errorMessageRedirectDeeplinkingThirdPartyLogin;
      break;
    }
    default: {
      message = messages.errorMessageRedirectGeneral;
    }
  }
  return (
    <Alert
      severity="error"
      variant="filled"
      data-testid="RedirectErrorMessage"
      sx={(theme) => ({
        marginTop: theme.spacing(4)
      })}
    >
      <FormattedMessage {...message} />
    </Alert>
  );
}
